import ApplicationInstance from '@ember/application/instance';
import PowerSelectControl from 'uplisting-frontend/components/bs-form/element/control/power-select/index';

/**
 * register `bs-form/element/control/power-select` component
 * as `ember-bootstrap-power-select` is not compatible with the strictest embroider mode
 */
export function initialize(appInstance: ApplicationInstance) {
  appInstance.register(
    'component:bs-form/element/control/power-select',
    PowerSelectControl,
  );
}

export default {
  initialize,
};
